import type { ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import {
  BUTTON_BASE,
  BUTTON_SIZES,
  BUTTON_VARIANTS,
  PRIMARY_BG,
  type ButtonSize,
  type ButtonVariant,
} from '@l2u/ui/components/buttonStyles.ts';

type Props = LinkProps & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
};

export function LinkBtn({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  style,
  ...rest
}: Props) {
  const variantStyle = variant === 'primary' ? { backgroundColor: PRIMARY_BG, ...style } : style;
  return (
    <Link
      className={`${BUTTON_BASE} ${BUTTON_SIZES[size]} ${BUTTON_VARIANTS[variant]} ${className}`}
      style={variantStyle}
      {...rest}
    >
      {children}
    </Link>
  );
}
